











































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { IAgency, IPolicy } from 'admiral-core';
import dayjs from 'dayjs';
import { BookIcon } from 'vue-feather-icons';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

@Component({
  components: {
    BookIcon,
  },
})
export default class UpcomingAntragsbuchCard extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: true }) subtitle!: string;
  @Prop({ type: Array, default: () => [] }) policiesAb!: IPolicy[];
  @Prop({ type: Object, required: false }) agency!: IAgency;

  activeTab: 'start' | 'end' = 'start';

  get currentPolicies() {
    const list =
      this.activeTab === 'start'
        ? this.startPolicies
        : this.activeTab === 'end'
        ? this.endPolicies
        : [];
    return [...list].sort((a, b) => {
      const dateA = dayjs(this.getRelevantDate(a));
      const dateB = dayjs(this.getRelevantDate(b));
      return dateA.valueOf() - dateB.valueOf();
    });
  }

  get startPolicies() {
    const today = dayjs().startOf('day');
    const inSevenDays = today.add(7, 'day');

    return this.policiesAb.filter((policy) => {
      const startDate = policy.antragsbuchData?.policyStartAt;
      if (!startDate) return false;

      const date = dayjs(startDate);
      return date.isSameOrAfter(today, 'day') && date.isSameOrBefore(inSevenDays, 'day');
    });
  }

  get endPolicies() {
    const today = dayjs().startOf('day');
    const inSevenDays = today.add(7, 'day');

    return this.policiesAb.filter((policy) => {
      const endDate = policy.antragsbuchData?.policyEndAt;
      if (!endDate) return false;

      const date = dayjs(endDate);
      return date.isSameOrAfter(today, 'day') && date.isSameOrBefore(inSevenDays, 'day');
    });
  }

  get limitedCurrentPolicies() {
    return this.currentPolicies.slice(0, 7);
  }

  getRelevantDate(policy: IPolicy) {
    if (this.activeTab === 'start') {
      return policy.antragsbuchData && policy.antragsbuchData.policyStartAt;
    } else {
      return policy.antragsbuchData && policy.antragsbuchData.policyEndAt;
    }
  }

  formatDate(date: string | Date | undefined) {
    if (!date) return '';
    return dayjs(date).format('DD.MM.YY');
  }

  formatBonus(bonus: number | undefined) {
    if (!bonus && bonus !== 0) return '';
    return bonus.toLocaleString('de-DE') + ' €';
  }

  getTooltipContent(policy: IPolicy): string {
    const data = [
      `Produkt: ${policy.product?.name || '--'}`,
      `Mitarbeiter: ${policy.user ? policy.user.firstname + ' ' + policy.user.lastname : '--'}`,
      `${this.agency?.wording?.value}: ${
        policy.value != null ? policy.value.toLocaleString('de-DE') : '--'
      }`,
      `Jahresnettobeitrag: ${
        policy.jahresNettoBeitrag != null
          ? policy.jahresNettoBeitrag.toLocaleString('de-DE') + ' €'
          : '-- €'
      }`,
      `Anzahl: ${policy.quantity != null ? policy.quantity : '--'}`,
      `VNR: ${policy.antragsbuchData?.vnr || '--'}`,
      `Bonus: ${
        policy.antragsbuchData?.bonus != null
          ? policy.antragsbuchData.bonus.toLocaleString('de-DE') + ' €'
          : '-- €'
      }`,
      `KVMOB: ${
        policy.antragsbuchData?.kvmob !== null
          ? policy?.antragsbuchData?.kvmob?.toLocaleString('de-DE') + ' €'
          : '-- €'
      }`,
      `LVBSU: ${
        policy.antragsbuchData?.lvbsu !== null
          ? policy?.antragsbuchData?.lvbsu?.toLocaleString('de-DE') + ' €'
          : '-- €'
      }`,
    ];

    return data.join('<br>');
  }
}
